import * as React from "react";

export abstract class BaseRowFactory<TComponentConstructor extends new (...args: any[]) => BaseRow<any> = typeof BaseRow, TData = {}, TInput = {}, TDisplay = {}> {
  TData!: TData
  TInput!: TInput
  TDisplay!: TDisplay

  abstract generate(input?: this['TInput']): TData;
  convertInput(input?: this['TInput']): this['TInput'] { return input! }
  convertDisplay(display?: this['TDisplay']): this['TDisplay'] { return display! }

  component!: TComponentConstructor
}

export interface BaseRowComponentProps<TData, TInput, TDisplay> {
  name: string
  title?: string
  titleMonospaced?: boolean
  data: TData
  input: TInput
  display: TDisplay

  setData: (data?: TData) => void,
  setInput: (input?: TInput) => void,
  setDisplay: (display?: TDisplay) => void,

  style?: React.CSSProperties
  className?: string
}

export interface BaseRowComponentState {

}

export class BaseRow<TRow extends BaseRowFactory<typeof BaseRow>, TState = {}> extends React.Component<
  BaseRowComponentProps<TRow['TData'], TRow['TInput'], TRow['TDisplay']>,
  BaseRowComponentState & TState
> {
  TData!: TRow['TData']
  TInput!: TRow['TInput']
  TDisplay!: TRow['TDisplay']
  TState!: TState

  render() {
    return <>
      <div className={`row-header ${this.props.className || ""}`} style={this.props.style}>
        <span>{this.props.titleMonospaced ? <code>{this.props.title || this.props.name}</code> : (this.props.title || this.props.name)}</span>
      </div>
      <div className={`row-data ${this.props.className || ""}`} style={this.props.style}>
        {this.props.data ? this.renderData() : this.renderEmptyData()}
      </div>
    </>
  }

  renderData(): React.ReactChild {
    return <></>;
  }

  renderEmptyData() {
    return <span>(Empty)</span>
  }

}
